import { HOTKEY_LAYER_ORDER } from '@/ui/utilities/hotkey/constants/HotkeyLayerOrder';
import { type HotkeyLayer } from '@/ui/utilities/hotkey/types/HotkeyLayer';

export const getTopHotkeyLayer = (
  openHotkeyLayers: readonly HotkeyLayer[],
): HotkeyLayer =>
  HOTKEY_LAYER_ORDER.findLast((layer) => openHotkeyLayers.includes(layer)) ??
  'page';
